import {
  View,
  Text,
  ActivityIndicator,
  TextInput
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { mapSelectValue } from '../../../utils'
import { CheckBox } from 'react-native-elements'

const MnInformationForm = ({ navigation, route }: any) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        essFormKey
    } = params

    const { loading, postmnonline, getmodetails } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()


    const intialValues = {
        martialStatus: "",
        selectingSection: "",
        claimasdependent: "",
        haveonejob: "",
        married: "",
        dependents: "",
        filingstatusHead: "",
        minnesotaallowances: "",
        additionalwithholding: "",
        minnesotaexemptions: "",
        stateofdomicle: "",
        reservationname: "",
        cdibnumber: ""

    }

    const options1 = [
        { key: 1, value: 'Single; Married, but legally separated; or Spouse is a nonresident alien' },
        { key: 2, value: 'Married' },
        { key: 3, value: 'Married, but withholding at higher single rate' }
    ]
    const options2 = [
        { key: 1, value: 'Section 1 — Determining Minnesota Allowances' },
        { key: 2, value: 'Section 2 — Exemption From Minnesota Withholding' },

    ]


    const handleReset1 = (props: any) => {
        props.setFieldValue('claimasdependent', '')
        props.setFieldValue('haveonejob', '')
        props.setFieldValue('married', '')
        props.setFieldValue('dependents', '')
        props.setFieldValue('filingstatusHead', '')
        props.setFieldValue('minnesotaallowances', '')
        props.setFieldValue('additionalwithholding', '')
    }

    const handleReset2 = (props: any) => {
        props.setFieldValue('minnesotaexemptions', "")
        props.setFieldValue('stateofdomicle', '')
        props.setFieldValue('reservationname', '')
        props.setFieldValue('cdibnumber', '')
    }




    const paschema = yup.object({
        martialStatus: yup.string().required("Martial status is a required field"),
        selectingSection: yup.string().required("Complete section 1 or section2 is a required field"),
        claimasdependent: yup.string().matches(/^1$/, "Enter '1' or leave it empty").nullable(),
        haveonejob: yup.string().matches(/^1$/, "Enter '1' or leave it empty").nullable(),
        married: yup
            .string()
            .nullable()
            .test(
                'valid-married',
                "Only '0', '1', or empty value is allowed",
                function (value) {
                    if (!value) return true; // allow empty/null
                    return /^[01]$/.test(value);
                }
            ),
        dependents: yup.string().nullable(),
        filingstatusHead: yup.string().matches(/^1$/, "Enter '1' or leave it empty").nullable(),
        // minnesotaallowances: yup
        //     .string()
        //     .when('selectingSection', (selectingSection: any, schema) => {
        //         if (selectingSection == 1) {
        //             return schema.required(
        //                 'Minnesota Allowances is a required field'
        //             )
        //         }
        //         return schema.nullable()
        //     }),
        additionalwithholding: yup
            .string()
            .when('selectingSection', (selectingSection: any, schema) => {
                if (selectingSection == 1) {
                    return schema.required(
                        'Additional withholding is a required field'
                    )
                }
                return schema.nullable()
            }),
        minnesotaexemptions: yup
            .mixed()
            .when('selectingSection', (selectingSection: any, schema) => {
                if (selectingSection == 2) {
                    return schema.required(
                        'Minnesota Exemptions is a required field'
                    )
                }
                return schema.nullable()
            }),
        stateofdomicle: yup
            .string()
            .when('minnesotaexemptions', (minnesotaexemptions: any, schema) => {
                if (minnesotaexemptions == 3) {
                    return schema.required(
                        'State of domicle is a required field'
                    )
                }
                return schema.nullable()
            }),
        reservationname: yup
            .string()
            .when('minnesotaexemptions', (minnesotaexemptions: any, schema) => {
                if (minnesotaexemptions == 4) {
                    return schema.required(
                        'Reservation name is a required field'
                    )
                }
                return schema.nullable()
            }),
        cdibnumber: yup
            .string()
            .when('minnesotaexemptions', (minnesotaexemptions: any, schema) => {
                if (minnesotaexemptions == 4) {
                    return schema.required(
                        'CDIB Number is a required field'
                    )
                }
                return schema.nullable()
            }),
    })

    interface CheckboxItem {
        id: number;
        title: string;
        bullets?: string[];
    }

    const checkboxData: CheckboxItem[] = [
        {
            id: 1,
            title: 'I meet the requirements and claim exempt from both federal and Minnesota income tax withholding'
        },
        {
            id: 2,
            title: 'Even though I did not claim exempt from federal withholding, I claim exempt from Minnesota withholding, because:',
            bullets: [
                'I had no Minnesota income tax liability last year',
                'I received a refund of all Minnesota income tax withheld',
                'I expect to have no Minnesota income tax liability this year'
            ]
        },
        {
            id: 3,
            title: 'All of these apply:',
            bullets: [
                'My spouse is a military service member assigned to a military location in Minnesota',
                'My domicile (legal residence) is in another state',
                'I am in Minnesota solely to be with my spouse.'
            ]
        },
        {
            id: 4,
            title: 'I am an American Indian that resides and works on a reservation for which I am enrolled (see instructions).'
        },
        {
            id: 5,
            title: 'I am a member of the Minnesota National Guard or an active-duty U.S. military member and claim exempt from Minnesota withholding on my military pay'
        },
        {
            id: 6,
            title: 'I receive a military pension or other military retirement pay as calculated under U.S. Code, title 10, sections 1401 through 1414, 1447 through 1455, and 12733, and I claim exempt from Minnesota withholding on this retirement pay'
        },
    ];

    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'MN Withholding Taxation '}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={paschema}
                    onSubmit={async (values, actions) => {
                        const total =
                            (Number(values?.claimasdependent) || 0) +
                            (Number(values?.haveonejob) || 0) +
                            (Number(values?.married) || 0) +
                            (Number(values?.dependents) || 0) +
                            (Number(values?.filingstatusHead) || 0);

                        const data = {
                            entityId: personalstore.personalData?.entityId,
                            essUserKey: initializestore?.initializeData?.userkey,
                            essObKey: essUserOnBoardingKey,
                            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
                            completeOnline: mode === 'online' ? true : false,
                            martialStatus: values?.martialStatus?.toString(),
                            claimAsDependent: values?.claimasdependent,
                            haveOneJob: values?.haveonejob,
                            married: values?.married,
                            dependents: values?.dependents,
                            filingStatusHead: values?.filingstatusHead,
                            minnesotaAllowances: total?.toString(),
                            additionalWithholding: values?.additionalwithholding,
                            minnesotaExemptions: values?.minnesotaexemptions?.toString(),
                            stateOfDomicle: values?.stateofdomicle,
                            reservationName: values?.reservationname,
                            cdibnumber: values?.cdibnumber,
                            total: total?.toString(),
                            Section: values?.selectingSection?.toString()
                        }

                        const response: any = await postmnonline(data)

                        if (response?.success) {
                            if (mode === 'online') {
                                navigation.navigate('MnInformationOnline', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values,
                                    total,
                                    essFormKey,
                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                        } else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }
                    }}
                >
                    {(props) => (
                        <>
                            <Card>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Martial status *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Martial status"
                                            options={options1}
                                            selectedOption={mapSelectValue(
                                                options1,
                                                props.values.martialStatus
                                            )}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('martialStatus', option - 1)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.martialStatus &&
                                            props.errors.martialStatus && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.martialStatus}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Select any of the following *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Select any of the following"
                                            options={options2}
                                            selectedOption={mapSelectValue(
                                                options2,
                                                props.values.selectingSection
                                            )}
                                            onSelect={(option: any) => {
                                                if (option == 2) {
                                                    handleReset1(props)
                                                }
                                                else {
                                                    handleReset2(props)
                                                }
                                                props.setFieldValue('selectingSection', option)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.selectingSection &&
                                            props.errors.selectingSection && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.selectingSection}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                {Number(props.values.selectingSection) == 1 ? <>
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ width: '70%', justifyContent: 'center' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {
                                                    'Enter “1” if no one else can claim you as a dependent'
                                                }
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.claimasdependent}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('claimasdependent')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.claimasdependent &&
                                                props.errors.claimasdependent && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.claimasdependent as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>

                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ width: '70%', justifyContent: 'center' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {`Enter “1” if any of the following apply:\n
• You are single and have only one job\n
• You are married, have only one job, and your spouse does not work\n
• Your wages from a second job or your spouse’s wages are $1500 or less`}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.haveonejob}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('haveonejob')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.haveonejob &&
                                                props.errors.haveonejob && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.haveonejob as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>


                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ width: '70%', justifyContent: 'center' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                Enter “1” if you are married. Or choose to enter “0” if you are married and have either a working
                                                spouse or more than one job. (Entering “0” may help you avoid having too little tax withheld.)
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.married}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('married')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.married &&
                                                props.errors.married && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.married as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ width: '70%', justifyContent: 'center' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                Enter the number of dependents (other than your spouse or yourself)
                                                you will claim on your tax return
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.dependents}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('dependents')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.dependents &&
                                                props.errors.dependents && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.dependents as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ width: '70%', justifyContent: 'center' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                Enter “1” if you will use the filing status Head of Household
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.filingstatusHead}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('filingstatusHead')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.filingstatusHead &&
                                                props.errors.filingstatusHead && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.filingstatusHead as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>



                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ width: '70%', justifyContent: 'center' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                Additional Minnesota withholding you want deducted for each pay period *
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.additionalwithholding}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('additionalwithholding')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.additionalwithholding &&
                                                props.errors.additionalwithholding && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.additionalwithholding as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>

                                </> : <></>}

                                {Number(props.values.selectingSection) == 2 ? <>
                                    <View
                                        style={[
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {
                                                    'Complete Section 2 if you claim to be exempt from Minnesota income tax withholding (see Section 2 instructions for qualifications). If applicable,check one box below to indicate why you believe you are exempt:'
                                                }
                                            </Text>
                                        </View>
                                        <View style={{ flexDirection: "row", flexWrap: "wrap", overflow: 'hidden' }}>
                                            {checkboxData.map(checkbox => (
                                                <CheckBox
                                                    key={checkbox.id}
                                                    title={
                                                        <View style={{ flex: 1, marginLeft: 10 }}>
                                                            <Text style={{
                                                                fontWeight: "normal",
                                                                color: "#0B495C",
                                                                fontSize: 14,
                                                                lineHeight: 20,
                                                            }}>
                                                                {checkbox.title}
                                                            </Text>
                                                            {checkbox.bullets && checkbox.bullets.map((bullet, idx) => (
                                                                <View key={idx} style={{ flexDirection: "row", marginTop: 6, paddingLeft: 12 }}>
                                                                    <Text style={{ marginRight: 6, color: "#0B495C", fontSize: 14 }}>•</Text>
                                                                    <Text style={{
                                                                        flex: 1,
                                                                        color: "#0B495C",
                                                                        fontSize: 14,
                                                                        lineHeight: 18,
                                                                    }}>
                                                                        {bullet}
                                                                    </Text>
                                                                </View>
                                                            ))}
                                                        </View>
                                                    }
                                                    checked={Number(props.values.minnesotaexemptions) === checkbox.id}
                                                    onPress={() => {
                                                        props.setFieldValue("minnesotaexemptions", checkbox.id)

                                                        if (checkbox.id !== 3) {
                                                            props.setFieldValue('stateofdomicle', "")
                                                        }
                                                        if (checkbox.id !== 4) {
                                                            props.setFieldValue('reservationname', "")
                                                            props.setFieldValue('cdibnumber', "")
                                                        }
                                                    }}
                                                    checkedColor="#0B495C"
                                                    uncheckedColor="#0B495C"
                                                    containerStyle={{
                                                        backgroundColor: 'transparent',
                                                        borderWidth: 0,
                                                        width: '100%',
                                                        alignItems: 'flex-start',
                                                        margin: 0,
                                                        padding: 0,
                                                        paddingVertical: 10,
                                                    }}
                                                />
                                            ))}
                                        </View>
                                        {props.touched.minnesotaexemptions &&
                                            props.errors.minnesotaexemptions && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.minnesotaexemptions as string}
                                                </Text>
                                            )}
                                    </View>


                                </> : <></>}

                                {Number(props.values.minnesotaexemptions) == 3 ?
                                    <>
                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ width: '70%', justifyContent: 'center' }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    Enter state of domicile *
                                                </Text>
                                            </View>
                                            <View style={{ width: '28%', overflow: 'hidden' }}>
                                                <TextInput
                                                    style={[globalStyles.input, globalStyles.inputLight]}
                                                    value={props.values.stateofdomicle}

                                                    onChangeText={(text) => {

                                                        props.handleChange('stateofdomicle')(text)

                                                    }}
                                                />
                                                {props.touched.stateofdomicle &&
                                                    props.errors.stateofdomicle && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.stateofdomicle as string}
                                                        </Text>
                                                    )}
                                            </View>
                                        </View>

                                    </>
                                    : <></>}

                                {Number(props.values.minnesotaexemptions) == 4 ?
                                    <>
                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ width: '70%', justifyContent: 'center' }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    Enter the reservation name *
                                                </Text>
                                            </View>
                                            <View style={{ width: '28%', overflow: 'hidden' }}>
                                                <TextInput
                                                    style={[globalStyles.input, globalStyles.inputLight]}
                                                    value={props.values.reservationname}

                                                    onChangeText={(text) => {
                                                        props.handleChange('reservationname')(text)
                                                    }}
                                                />
                                                {props.touched.reservationname &&
                                                    props.errors.reservationname && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.reservationname as string}
                                                        </Text>
                                                    )}
                                            </View>
                                        </View>

                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ width: '70%', justifyContent: 'center' }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    Enter your Certificate of Degree of Indian Blood (CDIB)/Enrollment number *
                                                </Text>
                                            </View>
                                            <View style={{ width: '28%', overflow: 'hidden' }}>
                                                <TextInput
                                                    style={[globalStyles.input, globalStyles.inputLight]}
                                                    value={props.values.cdibnumber}

                                                    onChangeText={(text) => {

                                                        props.handleChange('cdibnumber')(text)

                                                    }}
                                                />
                                                {props.touched.cdibnumber &&
                                                    props.errors.cdibnumber && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.cdibnumber as string}
                                                        </Text>
                                                    )}
                                            </View>
                                        </View>
                                    </>
                                    : <></>}


                                {loading ? (
                                    <ActivityIndicator />
                                ) : (
                                    <View style={{ margin: 10 }}>
                                        <CustomButton
                                            text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                            onPress={props.handleSubmit}
                                        />
                                    </View>
                                )}

                            </Card>
                        </>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>

    )
}

export default MnInformationForm
